import { apiClient } from '../../../utilities/apiClient';

// Cursor cache keyed by page index — mirrors AnonymousUsers/saga. Cleared
// from the page's unmount effect to avoid serving stale rows after the
// admin bounces between tabs.
const cursorByPage = new Map();
export const clearCursorCache = () => cursorByPage.clear();

export const fetchPhoneVerifications = async ({ page, docLimit }) => {
  const cursor = page === 0 ? null : cursorByPage.get(page - 1) ?? null;
  const res = await apiClient.get('/admin/phone-verifications', {
    params: { limit: docLimit, ...(cursor ? { cursor } : {}) },
  });
  const items = res.data.items ?? [];
  if (res.data.nextCursor) cursorByPage.set(page, res.data.nextCursor);
  return items;
};

export const getCountOfPendingVerifications = async () => {
  const res = await apiClient.get('/admin/phone-verifications/count');
  return res.data.count ?? 0;
};

export const verifyPhoneVerification = ({ id, phone }) =>
  apiClient.post(`/admin/phone-verifications/${id}/verify`, { phone });
